module.exports = __webpack_public_path__ + "fonts/opensans-semibold.71cbcff1.woff2";